/**
 * コンテンツアコーディオン
 */

const windowInfo = require('../common/window_info');
const useTransition = require('../support/transition');

(function ($) {
  $.fn.extend({
    contentsAccordion(options) {
      const o = $.extend(
        {
          itemClass: '.p-treatmentIndex__body',
          triggerClass: '.p-treatmentIndex__button',
          bodyClass: '.p-treatmentList__wrap',
          activeClass: 'is-active',
          duration: 300,
        },
        options,
      );
      return this.each(function () {
        const $contentsList = $(this);
        const $item = $contentsList.find(o.itemClass);
        let openHeight;
        const closeHeight = 0;
        let flg = false;
        let $thisItem;
        let $trigger;
        let $thisBody;
        let itemPadding;
        let winSize;
        let timer;

        function getHeight($element) {
          itemPadding =
            parseInt($element.css('paddingTop'), 10) +
            parseInt($element.css('paddingBottom'), 10) +
            parseInt($element.css('borderTopWidth'), 10) +
            parseInt($element.css('borderBottomWidth'), 10);

          return $element.outerHeight() + itemPadding;
        }

        function init() {
          $item.each(function (e) {
            $thisItem = $(this);

            $trigger = $thisItem.find(o.triggerClass);
            $thisBody = $thisItem.find(o.bodyClass);

            $trigger.attr({
              role: 'button',
              'aria-controls': `accordion${e}`,
              id: `tab${e}`,
            });

            openHeight = getHeight($thisBody);

            $thisBody.attr({
              'data-openheight': openHeight,
              'data-closeheight': closeHeight,
              'aria-hidden': true,
              'aria-expanded': false,
              'aria-labelledby': `tab${e}`,
              id: `accordion${e}`,
            });
            $thisBody.css({
              height: `${closeHeight}px`,
            });
          });
          winSize = windowInfo.width();
        }

        function setHeight() {
          if (winSize !== windowInfo.width()) {
            $item.each(function () {
              $thisItem = $(this);

              $trigger = $thisItem.find(o.triggerClass);
              $thisBody = $thisItem.find(o.bodyClass);

              openHeight = getHeight($thisBody);

              $thisBody.attr({
                'data-openheight': openHeight,
                'data-closeheight': closeHeight,
              });
              $thisBody.css(
                `${useTransition.prefix}transition-duration`,
                '0.01s',
              );
              $thisBody.css({
                height: `${closeHeight}px`,
              });
              $thisBody.css(`${useTransition.prefix}transition-duration`, '');
            });
            winSize = windowInfo.width();
          }
        }

        init();

        $(window).on('orientationchange', () => {
          setHeight();
        });

        $(window).on('resize', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            setHeight();
          }, 300);
        });

        $contentsList.on('click', o.triggerClass, function () {
          if (!flg) {
            flg = true;
            $thisItem = $(this).parent();
            $thisBody = $thisItem.find(o.bodyClass);
            if ($thisBody.hasClass(o.activeClass)) {
              $thisBody.css('height', `${$thisBody.data('closeheight')}px`);
              $thisBody.removeClass(o.activeClass);
              $thisBody.attr({
                'aria-hidden': true,
                'aria-expanded': false,
              });
            } else {
              $thisBody.css('height', `${$thisBody.data('openheight')}px`);
              $thisBody.addClass(o.activeClass);
              $thisBody.attr({
                'aria-hidden': false,
                'aria-expanded': true,
              });
            }
          }
        });
        $contentsList.on(useTransition.end, o.bodyClass, (e) => {
          if (e.originalEvent.propertyName === 'height') {
            flg = false;
          }
        });
      });
    },
  });
})(jQuery);
